<template>
    <el-dialog class="productTypeDialog" :append-to-body="true" title="" :visible.sync="applyProjectShow" width="70%">
        <div class="Apply-Project">
            <h5 style="margin-bottom: 10px">审批人配置</h5>
<!--            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">-->
<!--                <el-form-item>-->
<!--                    <el-input v-model="dataForm.key" placeholder="参数名" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                    <el-button @click="getDataList()">查询</el-button>-->
<!--                </el-form-item>-->
<!--            </el-form>-->

            <div class="Apply">
                <div class="Apply-P" v-for="(item,index) in applyData" :key="index">
                    <el-descriptions style="padding: 20px;padding-bottom: 0;" title="">
                        <el-descriptions-item label="审批类目">{{ item.approvalKind }}</el-descriptions-item>
                        <el-descriptions-item label="所属公司">{{ item.createCompanyName }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="审批类型">
                            <el-tag size="small">
                                <span v-if="item.type==0">单级审批</span>
                              <span v-if="item.type==1">多级审批</span>
                            </el-tag>
                        </el-descriptions-item> -->
                    </el-descriptions>
                    <div class="Apply-People" :style="{padding: item.hierarchy.length==0? '0' : '20px'}">
                        <div class="Apply-People-Step" v-for="(step,sindex) in item.step" :key="sindex">
                            <div class="Apply-People-For" v-for="(people,pindex) in setShowDel(item.hierarchy,step)" :key="pindex" @mouseenter="enter(people)" @mouseleave="leave(people)">
                                <img v-if="people.imageUrl===''" src="@/assets/png/moren.png" alt="">
                                <img v-else :src="people.imageUrl" alt="">
                                <p><span>审批人：</span>{{ people.applyName }}</p>
                                <p><span>审批层级：</span>{{ people.step }}</p>
                                <p><span>消息提示：</span>{{ people.tipInfo == 0 ? '公众号' : people.tipInfo == 1 ? '邮箱' : '短信' }}</p>
                                <div v-if="people.show" class="Top-Apply">
                                    <span @click="delHierarchy(people.id,item.id)">删除</span>
                                    <span @click="setHierarchy(0,item.id,people.step)">添加</span>
                                </div>
                            </div>
                            <div v-if="sindex+1<item.step" class="Apply-People-Step-Line">
                                <div class="mydiv"></div>
                            </div>
                        </div>
                        <div v-if="item.type==1" style="margin-left: 30px;display: flex;align-self: center;padding-bottom:10px">
                            <a style="font-size:12px;text-decoration: underline;" @click="setHierarchy(0,item.id,'')" href="#">点击增加审批层级</a>
                        </div>
                    </div>
                </div>
            </div>
            <HierarchyAddOrUpdate ref="hierarchyAddOrUpdate" @refreshDataList="getDataList"></HierarchyAddOrUpdate>
        </div>
    </el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Api from '@/components/Api/index'
import HierarchyAddOrUpdate from './Hierarchy-add-or-update'

export default {
    name: 'ApplyProject',
    components: {
        HierarchyAddOrUpdate
    },
    // 定义属性
    data() {
        return {
            dataForm: {
                key: ''
            },
            applyData: [],
            applyProjectShow: false
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
        setShowDel() {
            return function (hierarchy, step) {
                hierarchy.forEach(x => {
                    if (x.show == undefined) {
                        x.show = false
                    }
                })
                return hierarchy.filter(x => x.step == step)
            }
        }
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        init() {
            this.applyProjectShow = true
            this.getDataList()
        },
        delHierarchy(id, configId) {
            this.$confirm('此操作将删除此审批人, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                new Api("apply").hierarchyDel(id, configId).then(res => {
                    if (res.status == 200) {
                        this.$message.success("删除成功");
                        this.getDataList()
                    }
                })
            })
        },
        enter(item) {
            item.show = true
            this.$forceUpdate()
        },
        leave(item) {
            item.show = false
            this.$forceUpdate()
        },
        setHierarchy(id, configId, step) {
            this.$refs.hierarchyAddOrUpdate.init(id, configId, step)
        },
        getDataList() {
            new Api("apply").approvalProjectList().then((result) => {
                if (result.status == 200) {
                    this.applyData = result.data
                }
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.getDataList()
    },
    beforeCreate() {
    }, // 生命周期 - 创建之前
    beforeMount() {
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
    }, // 生命周期 - 更新之前
    updated() {
    }, // 生命周期 - 更新之后
    beforeDestroy() {
    }, // 生命周期 - 销毁之前
    destroyed() {
    }, // 生命周期 - 销毁完成
    activated() {
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.Apply-P {
    border: 1px solid darkgray;
    border-radius: 10px;
    margin-bottom: 10px;

    .Apply-People {
        display: flex;
        padding: 20px;

        .Apply-People-Step {
            display: flex;
        }

        .Apply-People-Step-Line {
            width: 30px;
            height: 1px;
            background: black;
            display: flex;
            align-self: center;
            margin-left: 10px;
            margin-right: 10px;
            justify-content: flex-end;

            .mydiv {
                width: 10px;
                height: 10px;
                /* background: black; */
                transform: rotate(45deg);
                border-top: 1px solid;
                border-right: 1px solid;
                position: relative;
                /* display: flex; */
                top: -4.5px;
            }
        }

        .Apply-People-For {
            margin-right: 10px;
            margin-left: 10px;

            &:hover {
                cursor: pointer;
            }

            font-size: 12px;
            padding: 10px;
            border: 1px solid darkgray;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            text-align: center;
            position: relative;
            z-index: 1;

            .Top-Apply {
                position: absolute;
                width: 100%;
                left: 0;
                top: 0;
                background: var(--color);
                color: white;
                height: 25px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                border-radius: 10px 10px 0 0;
            }

            > img {
                width: 40px;
                height: 40px;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                margin-bottom: 10px;
            }

            > p {
                display: flex;
            }
        }
    }
}
</style>
